import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import * as crypto from 'asymmetric-crypto';
import { Subscription } from 'rxjs';

import { EditEventUserComponent } from '@app/home/wristband-details/event-details/edit-event-user/edit-event-user.component';
import { InfoComponent } from '@app/home/wristband-details/event-details/info/info.component';

import { BracelitEvent } from '@shared/models/bracelit/bracelit-event';
import { ApiService, AuthenticationService, SnackBarService, ThemeService } from '@shared/services';
import { DomainService } from '@shared/services/domain.service';
import { WristbandsService } from '@shared/services/wristbands.service';
import { EventConfigurationService } from '@shared/services/event-configuration.service';
import { environment } from '../../../../environments/environment';
import { PaymentHistoryComponent } from './payments/payment-history/payment-history.component';
import { QrDialogComponent } from './qr-dialog/qr-dialog.component';
import { IframeDialogComponent } from './iframe-dialog/iframe-dialog.component';
import { AcquiredVouchersComponent } from './acquired-vouchers/acquired-vouchers.component';
import { TranslateConfigService } from '@app/shared/services/translate-config.service';
import { MoneyReturnComponent } from './money-return/money-return.component';
import { QuestionaryComponent } from './questionary/questionary.component';
import { QuizComponent } from './quiz/quiz.component';
import { browserRefresh } from '../../../app.component';
import { InfoDevComponent } from './info-dev/info-dev.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationDialogComponent } from '@app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ReservedTicketsComponent } from './reserved-tickets/reserved-tickets.component';

@Component({
  selector: 'event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss'],
  standalone: false
})
export class EventDetailsComponent implements OnInit, OnDestroy {
  eventId = '';
  payGateway: string;
  event: BracelitEvent;
  wristbandId: any;
  encryptedWrist: any;
  routerSubscription: Subscription;
  loading = true;
  userHasToken: boolean;
  eventHasVouchers: boolean;
  tokenText: string;

  coinName: string;
  public accountLogo: string;
  private workerPublicKey = 'GoG97Q88PpxNc+BrbEWgupV3N+wO+riSSJIWz4UXtCM=';
  private secureQr: any;
  public leadScanner = false;
  public bidirectional = false;
  public onlineOrders = false;
  public productScanner = false;
  public obligatoryAssociation = false;
  private valor: string;
  selectedTheme: string;
  background: string;
  public showTooltip1 = false;
  @ViewChild('tooltip1') tooltip1: MatTooltip;
  accountEvent: any;
  domain: string;
  checked: boolean;
  eventIsTicketing = false;
  errorReturnNumber: number;
  codeWrist: string;
  intervalReturnMoney: any;
  intervalReturnMoneyStarting: any;
  intervalReturnMoneyEnding: any;
  intervalReturnMoneySend: any;
  returnMoneyCommission: any
  dataWrist: any = {};
  flagMBA = false; // FIN FUN (MBA KIDS)
  myForm: FormGroup; // FIN FUN (MBA KIDS)
  restrictAge: boolean = false;
  iframeVisible: boolean = false; // La taja
  currentLang: string;
  wristbandLabel: string;
  voucherLabelMinus: string;
  voucherLabelMayus: string;
  ticketLabelMinus: string;
  ticketLabelMayus: string;
  locale: string;
  messageElfSpain: string;
  hasPurchases: boolean;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private snackBar: SnackBarService,
    public dialog: MatDialog,
    public wristbandsService: WristbandsService,
    public authService: AuthenticationService,
    public themeService: ThemeService,
    public datepipe: DatePipe,
    private formBuilder: FormBuilder,
    private eventConfService: EventConfigurationService,
    private translateConfigService: TranslateConfigService,
    private domainService: DomainService) {

    this.currentLang = localStorage.getItem('lang') === 'es' ? 'es' : 'en';

    this.wristbandLabel = (this.currentLang === 'es') ? 'tu pulsera' : 'your wristband';
    this.voucherLabelMinus = (this.currentLang === 'es') ? 'bonos' : 'offers';
    this.voucherLabelMayus = (this.currentLang === 'es') ? 'BONOS' : 'OFFERS';
    this.ticketLabelMinus = (this.currentLang === 'es') ? 'entradas' : 'tickets';
    this.ticketLabelMayus = (this.currentLang === 'es') ? 'ENTRADAS' : 'TICKETS';

    this.locale = (this.currentLang === 'es') ? 'es-ES' : 'en-UK';
    this.messageElfSpain = (this.currentLang === 'es') ? '¡Te has registro correctamente! Pronto te enviaremos un email con el QR. Reserva aquí tus entradas para Cursos y Eventos.' : 'You have registered successfully! We will soon send you an email with a QR code. Book your tickets for Courses and Events here.'; // ELF SPAIN

    if (this.domainService.event && !this.domainService.event.hasWristbands) {
      this.wristbandLabel = (this.currentLang === 'es') ? (!this.domainService.event.hasQR ? 'tu pulsera' : 'tu monedero') : (!this.domainService.event.hasQR ? 'your wristband' : 'your wallet');
      this.event = this.domainService.event;
    }

    this.domain = environment.server;

    this.myForm = this.formBuilder.group({});
    this.myForm.addControl('money', new FormControl(0, Validators.required)); // FIN FUN (MBA KIDS)
  }

  async ngOnInit(): Promise<any> {
    if (browserRefresh) {
      await this.wristbandsService.fetchWristbands(!browserRefresh); //OPTIMIZACION GALLEGO: browserRefresh es true cuando la página se ha recargado dentro de este componente y false cuando llega desde otro componente
    }
    if (this.wristbandsService.selectedWristband !== null && this.wristbandsService.selectedWristband !== undefined) {
      this.checked = this.wristbandsService.selectedWristband['isActive'];
      const data = JSON.parse(this.wristbandsService.selectedWristband.data);
      if (data !== null) {
        if ((data.data !== null) && (data.data !== undefined)) {
          this.dataWrist = data.data;
        }
      }
    } else {
      this.router.navigate(['../home/listado-pulseras']);
    }
    this.accountLogo = localStorage.getItem('accountLogo');
    this.routerSubscription = this.route.paramMap.subscribe(async params => {
      const eventId = params.get('eventId');
      const wristbandId = params.get('wristbandId');
      const walletId = params.get('walletId');
      this.wristbandId = wristbandId;
      this.eventId = eventId;
      this.event = this.wristbandsService.selectedEvent;
      if (this.event !== null && this.event !== undefined) {
        this.eventConfService.setEvent(this.event);
        localStorage.setItem('accountId', JSON.stringify(this.event.accountId));
        localStorage.setItem('accountTheme', JSON.stringify(this.event.selectedTheme));
        this.themeService.selectTheme(JSON.stringify(this.event.selectedTheme));
        this.getSelectedTheme();
        this.coinName = this.event.coinName;
        if (this.wristbandsService.selectedWristband !== null && this.wristbandsService.selectedWristband !== undefined) {
          this.codeWrist = this.event.seeChinoCode ? (this.wristbandsService.selectedWristband.chinoCode !== null ? this.wristbandsService.selectedWristband.chinoCode.toUpperCase() : '') : (this.wristbandsService.selectedWristband.associatedQrId !== null ? this.wristbandsService.selectedWristband.associatedQrId : '');
        }
        if (this.event.accountFile !== undefined && this.event.accountFile !== null) {
          localStorage.setItem('accountLogo', this.event.accountFile);
          this.accountLogo = this.event.accountFile;
        } else {
          localStorage.setItem('accountLogo', '');
          this.accountLogo = '';
        }
        this.returnMoneyCommission = Number(this.event.returnMoneyCommission).toLocaleString("es-ES", {
          style: "currency",
          currency: "EUR",
        });
        if ((this.event.intervalStartingDate !== undefined) && (this.event.intervalEndingDate !== undefined) && (this.event.intervalStartingDate !== null) && (this.event.intervalEndingDate !== null)) {
          this.intervalReturnMoneyStarting = new Date(this.event.intervalStartingDate).toLocaleString(this.locale, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
          });
          this.intervalReturnMoneyEnding = new Date(this.event.intervalEndingDate).toLocaleString(this.locale, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
          });

          const endingDateSend = new Date(this.event.intervalEndingDate);
          endingDateSend.setDate(endingDateSend.getDate() + 1);
          this.intervalReturnMoneySend = endingDateSend.toLocaleString(this.locale, {
            month: 'long',
            day: 'numeric',
          });
        } else {
          this.intervalReturnMoneyStarting = null;
          this.intervalReturnMoneyEnding = null;
        }
        this.payGateway = this.event.paymentGatewayOption;
        this.eventHasVouchers = this.event.hasVouchers;
        this.eventIsTicketing = this.event.isTicketing;
        this.secureQr = this.event.hasSecurity;
        this.leadScanner = this.event.hasLeadScanner;
        this.bidirectional = this.event.hasBidirectionalLeadScanner;
        this.onlineOrders = this.event.hasOnlineOrders;
        this.productScanner = this.event.productScanner;
        this.obligatoryAssociation = this.event.obligatoryAssociation;
        this.hasPurchases = this.event.hasPurchases !== null && this.event.hasPurchases !== undefined ? this.event.hasPurchases : true;
        localStorage.setItem('paymentGateway', this.payGateway);
        if (this.event.hasQR) {
          this.wristbandLabel = (this.currentLang === 'es') ? 'tu monedero' : 'your wallet';
        }

        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }


  getSelectedTheme() {
    if (localStorage.getItem('accountTheme').split('"')[1] !== undefined) {
      this.selectedTheme = localStorage.getItem('accountTheme').split('"')[1];
    } else {
      this.selectedTheme = localStorage.getItem('accountTheme');
    }
    if ((this.selectedTheme === 'bracelit-theme') || (this.selectedTheme === 'bee-blue-theme')) {
      localStorage.setItem('accountLogo', '');
    }
  }

  openInfo(): void {
    const dialogRef = this.dialog.open(InfoComponent, {
      width: '500px',
      minWidth: '320px',
      maxWidth: '80vw',
      maxHeight: '65vh',
      minHeight: '250px',
      data: {
        info: this.event.info
      },
      autoFocus: false,
      restoreFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openInfoDev(): void {
    const dialogRef = this.dialog.open(InfoDevComponent, {
      width: '500px',
      minWidth: '320px',
      maxHeight: '65vh',
      height: '65vh',
      data: {
        intervalReturnMoneyStarting: this.intervalReturnMoneyStarting,
        intervalReturnMoneyEnding: this.intervalReturnMoneyEnding,
        intervalReturnMoneySend: this.intervalReturnMoneySend,
        returnMoneyCommission: this.returnMoneyCommission,
        event: { id: this.event.id },
      },
      autoFocus: false,
      restoreFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  setPaymentGateway() {
    const storedGateway = localStorage.getItem('paymentGateway');
    if (this.payGateway !== storedGateway) {
      localStorage.setItem('paymentGateway', this.payGateway);
    }
  }

  toggle(id) {
    if (id === 1) {
      if (!this.showTooltip1) {
        this.tooltip1.show();
      } else {
        this.tooltip1.hide();
      }
      this.showTooltip1 = !this.showTooltip1;
    }
  }

  onRechargeWristband(): void {
    const wristbands = JSON.parse(localStorage.getItem('wristbands'));
    const wristbandId = this.route.params['_value'].wristbandId;
    const wristband = wristbands.find(wrist => wrist.id === wristbandId);

    if (wristband) {
      this.router.navigate([`carrito/bracels`], { relativeTo: this.route });
    } else {
      this.authService.logout('../qr-inicial');
    }
  }

  onBuyVouchers(): void {
    const wristbands = JSON.parse(localStorage.getItem('wristbands'));
    const wristbandId = this.route.params['_value'].wristbandId;
    const wristband = wristbands.find(wrist => wrist.id === wristbandId);

    if (wristband) {
      this.router.navigate([`carrito/bonos`], { relativeTo: this.route });
    } else {
      this.authService.logout('../qr-inicial');
    }
  }

  onBuyTickets(): void {
    const wristbands = JSON.parse(localStorage.getItem('wristbands'));
    const wristbandId = this.route.params['_value'].wristbandId;
    const wristband = wristbands.find(wrist => wrist.id === wristbandId);

    if (wristband) {
      this.router.navigate([`carrito/tickets`], { relativeTo: this.route });
    } else {
      this.authService.logout('../qr-inicial');
    }
  }

  onViewReservedTickets(): void {
    const accountId = JSON.parse(localStorage.getItem('accountId'));
    const userId = this.authService.user.id;
    
    const dialogRef = this.dialog.open(ReservedTicketsComponent, {
      height: '65vh',
      maxHeight: '65vh',
      width: '500px',
      minWidth: '320px',
      data: {
        accountId: accountId,
        eventId: this.eventId,
        userId: userId,
        wristbandId: this.wristbandId
      }
    });

    dialogRef.afterClosed().subscribe(_result => {
    });
  }

  onBuyOnlineOrders(): void {
    // this.router.navigate([`pedidos`], { relativeTo: this.route });

    //const backofficeWindow = window.open('http://localhost:35441', '_blank');
    const backofficeWindow = window.open('https://pick.bracelit.es', '_blank');

    const rawToken = localStorage.getItem('token') || '';
    const token = rawToken.replace(/^"Bearer\s+|^Bearer\s+|"/g, '');

    const sendMessage = () => {
      //backofficeWindow?.postMessage({ token }, 'http://localhost:35441');
      backofficeWindow?.postMessage({ token }, 'https://pick.bracelit.es');
    };

    setTimeout(sendMessage, 2000);

    //window.open('https://pick.bracelit.es/home?token=' + this.authService.token.replace(/^"Bearer\s+|^Bearer\s+|"/g, ''), '_blank');
    //window.open('http://localhost:4200/home?token=' + this.authService.token.replace(/^"Bearer\s+|^Bearer\s+|"/g, ''), '_blank');
  }

  onOpenHistory(): void {
    if (this.themeService.checkDefault === true) {
      const dialogRef = this.dialog.open(PaymentHistoryComponent, {
        width: '500px',
        minWidth: '320px',
        maxHeight: '65vh',
        height: '65vh',
        data: {
          coinName: this.event.coinName,
          voucherLabelMinus: this.voucherLabelMinus,
          voucherLabelMayus: this.voucherLabelMayus,
          eventId: this.eventId,
          isTicketing: this.event.isTicketing
        },
        autoFocus: false,
        restoreFocus: false
      });

      dialogRef.afterClosed().subscribe(_result => {
      });
    } else {
      const dialogRef = this.dialog.open(PaymentHistoryComponent, {
        width: '500px',
        minWidth: '320px',
        maxHeight: '65vh',
        height: '65vh',
        data: {
          coinName: this.event.coinName,
          voucherLabelMinus: this.voucherLabelMinus,
          voucherLabelMayus: this.voucherLabelMayus,
          eventId: this.eventId,
          isTicketing: this.event.isTicketing
        },
        autoFocus: false,
        restoreFocus: false
      });

      dialogRef.afterClosed().subscribe(_result => {
      });
    }
  }

  onOpenAcquiredVouchers(): void {
    const walletId = this.wristbandsService.selectedWallet?.id;
    if (!walletId) {
      this.snackBar.openSnackBar(
        (this.currentLang === 'es')
          ? 'Error: No se encontró el monedero.'
          : 'Error: Wallet not found.'
      );
      return;
    }

    if (this.themeService.checkDefault === true) {
      const dialogRef = this.dialog.open(AcquiredVouchersComponent, {
        width: '500px',
        minWidth: '320px',
        maxHeight: '65vh',
        height: '65vh',
        data: {
          event: this.event,
          eventId: this.eventId,
          wristbandId: this.wristbandId,
          walletId: walletId
        },
        autoFocus: false,
        restoreFocus: false
      });

      dialogRef.afterClosed().subscribe(_result => {
        // El modal ya maneja su propia recarga, no necesitamos hacer nada aquí
      });
    } else {
      const dialogRef = this.dialog.open(AcquiredVouchersComponent, {
        width: '500px',
        minWidth: '320px',
        maxHeight: '65vh',
        height: '65vh',
        data: {
          event: this.event,
          eventId: this.eventId,
          wristbandId: this.wristbandId,
          walletId: walletId
        },
        autoFocus: false,
        restoreFocus: false
      });

      dialogRef.afterClosed().subscribe(_result => {
        // El modal ya maneja su propia recarga, no necesitamos hacer nada aquí
      });
    }
  }

  onLeadScanner(): void {
    this.wristbandsService.setEvent(this.event);
    this.wristbandsService.setRouteParams(this.route.params);
    localStorage.setItem('eventSelected', JSON.stringify(this.event));
    this.router.navigate([`lead-scanner`], { relativeTo: this.route });

    // if (this.themeService.checkDefault === true) {
    //   const dialogRef = this.dialog.open(LeadScannerComponent, {
    //     height: '100%',
    //     width: '100%',
    //     panelClass: ['full-screen-dialog'],
    //     data: {
    //       event : this.event,
    //       routeParams: this.route.params
    //     }
    //   });

    //   dialogRef.afterClosed().subscribe(_result => {
    //   });
    // } else {
    //   const dialogRef = this.dialog.open(LeadScannerComponent, {
    //     height: '100%',
    //     width: '100%',
    //     panelClass: ['full-screen-dialog'],
    //     data: {
    //       event: this.event,
    //       routeParams: this.route.params
    //     }
    //   });

    //   dialogRef.afterClosed().subscribe(_result => {
    //   });
    // }
  }


  onSeeQrCode(): void {
    if (this.secureQr) {
      const createdAt = new Date().toISOString();
      const userPrivateKey = 'GTeo3AX2tk78JwdQtEk6Is7LhoV7dQG42cju69zuKWLBRtbYqiTd1AoEgPJKNhGH93C/KLgpslB0WJ3unKPU6w==';
      // let latest_date =this.datepipe.transform(createdAt, 'yyyy-MM-dd H:mm');
      const data2encrypt = this.wristbandId + '==' + createdAt;
      this.encryptedWrist = crypto.encrypt(data2encrypt, this.workerPublicKey, userPrivateKey);
      this.valor = this.encryptedWrist.data + '==' + this.encryptedWrist.nonce;
    } else {
      this.valor = this.wristbandId;
    }
    const dialogRef = this.dialog.open(QrDialogComponent, {
      width: '500px',
      minWidth: '320px',
      data: {
        value: this.valor
      },
      autoFocus: false,
      restoreFocus: false
    });
  }

  editEventUserForm(): void {
    this.dialog.open(EditEventUserComponent, {
      width: '500px',
      minWidth: '320px',
      maxHeight: '65vh',
      height: '65vh',
      data: {
        eventId: this.eventId,
        hasEditableData: this.event.hasEditableData,
        isMoneyReturned: this.event.isMoneyReturned,
        money: this.wristbandsService.selectedWallet.money,
        code: this.wristbandsService.selectedWristband.chinoCode
      },
      autoFocus: false,
      restoreFocus: false
    });
  }

  goToMoneyReturned(): void {
    if ((this.wristbandsService.selectedWallet.money > 0) && (this.wristbandsService.selectedWristband.label === 'associated' || this.wristbandsService.selectedWristband['label'] === 'changed' || this.event.hasQR)) {
      this.apiService.get(`events/${this.eventId}/checkIsMoneyReturned`).subscribe({
        next: (data) => {
          if (data['isMoneyReturned']) {
            this.dialog.open(MoneyReturnComponent, {
              width: '500px',
              minWidth: '320px',
              maxHeight: '65vh',
              height: '65vh',
              data: {
                eventId: this.eventId,
                isMoneyReturned: this.event.isMoneyReturned,
                money: this.wristbandsService.selectedWallet.money,
                code1: this.wristbandsService.selectedWristband.chinoCode,
                code2: this.wristbandsService.selectedWristband.associatedQrId
              },
              autoFocus: false,
              restoreFocus: false
            });
          }
        },
        error: (err) => {
          console.error(err);
        }
      });
    } else {
      this.dialog.open(MoneyReturnComponent, {
        width: '500px',
        minWidth: '320px',
        maxHeight: '65vh',
        height: '65vh',
        data: {
          eventId: this.eventId,
          isMoneyReturned: this.event.isMoneyReturned,
          money: this.wristbandsService.selectedWallet.money,
          code1: this.wristbandsService.selectedWristband.chinoCode,
          code2: this.wristbandsService.selectedWristband.associatedQrId
        },
        autoFocus: false,
        restoreFocus: false
      });
    }
  }

  goToQuestionary(): void {
    this.dialog.open(QuestionaryComponent, {
      maxWidth: '95vw',
      width: '95vw',
      maxHeight: '80vh',
      height: '80vh',
      data: {
        eventId: this.eventId,
      },
      autoFocus: false,
      restoreFocus: false
    });
  }

  goToQuiz(): void {
    this.dialog.open(QuizComponent, {
      maxWidth: '95vw',
      width: '95vw',
      maxHeight: '80vh',
      height: '80vh',
      data: {
        eventId: this.eventId,
      },
      autoFocus: false,
      restoreFocus: false
    });
  }

  async activateOrDeactivate(e) {
    // if (confirm('¿Está seguro de que desea ' + (this.wristbandsService.selectedWristband['isActive'] ? 'desactivar' : 'activar') + ' su pulsera?')) {
    if (confirm(((this.currentLang === 'es') ? '¿Está seguro de que desea ' : 'Are you sure you want to ') + (this.wristbandsService.selectedWristband['isActive'] ? ((this.currentLang === 'es') ? 'desactivar' : 'desactivate') : ((this.currentLang === 'es') ? 'activar' : 'activate')) + ((this.currentLang === 'es') ? ' su pulsera?' : ' your wristband?'))) {
      this.apiService.patch(`accounts/${this.wristbandsService.selectedWristband['accountId']}/events/${this.eventId}/wristbands/${this.wristbandsService.selectedWristband['physicalId']}/activateOrDeactivate`, 'algo').subscribe(
        async data => {
          this.checked = !this.checked;
          this.wristbandsService.selectedWristband = data[0];
          await this.wristbandsService.fetchWristbands(false);
        });
    } else {
      e.source.checked = this.checked;
    }
  }

  onNavigateToNewWristband(): void {
    this.router.navigate([`/home/nueva-pulsera`], { relativeTo: this.route });
  }

  // CHAPUZA BANKUNION
  postBankunion() {
    const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      minWidth: '320px',
      data: '¿Está seguro de que desea que su pulsera sea a crédito?',
      autoFocus: false,
      restoreFocus: false
    });
    dialogRef2.afterClosed().subscribe(result => {
      if (result) {
        this.loading = true;
        this.apiService.post(`accounts/${this.wristbandsService.selectedWristband['accountId']}/events/${this.eventId}/wristbands/${this.wristbandsService.selectedWristband['id']}/addSocioTrueToData`, '').subscribe({
          next: (data) => {
            if (data.status === 200) {
              this.snackBar.openSnackBar('Operación realizada correctamente.');
              this.loading = false;
              this.router.navigate(['../home/listado-pulseras']);
            }
          },
          error: (err) => {
            console.error(err);
            this.snackBar.openSnackBar('No fue realizar la operación. Por favor, inténtelo de nuevo.');
            this.loading = false;
          }
        });
      }
    });
  }


  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  // CHAPUZA FIN FUN (MBA KIDS)
  changeFlagMBA() {
    this.flagMBA = !this.flagMBA;
  }

  changeMoneyMBA(value: number, save: boolean) {
    if (value === 0) {
      this.myForm.controls['money'].reset();
    } else {
      this.myForm.value.money = String(this.myForm.value.money * value);
      if (save) {
        this.loading = true;
        const money = Number(this.wristbandsService.selectedWallet.money) + Number(this.myForm.value.money);
        this.apiService.post(`wristbands/${this.wristbandsService.selectedWristband['id']}/updateWallet`, { money: money }).subscribe(
          async data => {
            if (data.status === 200) {
              this.flagMBA = false;
              this.myForm.controls['money'].reset();
              this.wristbandsService.selectedWallet.money = money;
              this.snackBar.openSnackBar(data.msg);
              this.loading = false;
            } else {
              this.snackBar.openSnackBar('Error');
              this.loading = false;
            }
          });
      }
    }
  }

  // CHAPUZA LA TAJÁ
  checkPrincipalMember() {
    if (this.dataWrist) {
      return (this.dataWrist.tipo === 'Socio principal');
    } else {
      return false;
    }
  }

  // CHAPUZA FALLA LA NOVA
  checkInvitado() {
    if (this.dataWrist) {
      return (this.dataWrist.category === 'white');
    } else {
      return false;
    }
  }

  abrirCarta(): void {
    const url = 'https://drive.google.com/file/d/1mQYacQ5RdB6eKGwv5YOpLrz2E2LpPIjF/view?usp=sharing';
    window.open(url, '_blank');
  }

  redirectEditProfile(): void {
    const url = 'https://la-taja.web.app';
    window.open(url, '_blank');
  }

  showIframe(): void {
    this.dialog.open(IframeDialogComponent, {
      width: '90%',
      height: '80%',
      autoFocus: false,
      restoreFocus: false
    });
  }

  // FESTIVAL DE LAS IDEAS
  goToPopUp(): void {
    const dialogRef = this.dialog.open(QuizComponent, {
      maxWidth: '95vw',
      width: '95vw',
      maxHeight: '50vh',
      height: '50vh',
      data: {
        eventId: this.eventId,
      },
      autoFocus: false,
      restoreFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.goToPay();
      }
    });
  }

  goToPay() {
    const wristbands = JSON.parse(localStorage.getItem('wristbands'));
    const wristbandId = this.route.params['_value'].wristbandId;
    const wristband = wristbands.find(wrist => wrist.id === wristbandId);

    if (wristband) {
      this.router.navigate([`carrito/bracels`], { relativeTo: this.route, queryParams: { pay: 'true' } });
    } else {
      this.authService.logout('../qr-inicial');
    }
  }

}
